/**
 * Bloc Compo JS
 */

jQuery(document).ready(function($){

});